import { jsx } from "react/jsx-runtime";
import "react";
import useConfigWithExtraValidation from "../../utils/form/useExtraFieldValidation.esm.js";
import { MAX_NAME_LENGTH } from "./Constants.esm.js";
import TextField from "./TextField.esm.js";
function getInvalidNameError(value) {
  if (typeof value !== "string") {
    return "Please enter a valid name";
  }
  if (value.length > MAX_NAME_LENGTH) {
    return "Name is too long (maximum 250 characters)";
  }
  if (value.startsWith(" ")) {
    return "Name cannot start with spaces";
  }
  const trimmedValue = value.trim();
  if (!trimmedValue) {
    return "Please enter a valid name";
  }
  const nameParts = trimmedValue.replace(/\s+/g, " ").split(" ");
  if (nameParts.length < 2) {
    return "Please enter both first and last name";
  }
  const BASIC_LATIN = "A-Za-z";
  const LATIN_SUPPLEMENT = "À-ÖØ-öø-ÿ";
  const SPECIAL_CHARS = "\\s'-";
  const nameRegex = new RegExp(`^[${BASIC_LATIN}${LATIN_SUPPLEMENT}${SPECIAL_CHARS}]+$`);
  if (/['-]{2,}/.test(trimmedValue)) {
    return "Name contains consecutive special characters";
  }
  if (nameParts.some((part) => /^[-']|[-']$/.test(part))) {
    return "Names cannot start or end with special characters";
  }
  if (!nameRegex.test(trimmedValue)) {
    return "Name contains invalid characters";
  }
  return null;
}
function NameField(textFieldProps) {
  return /* @__PURE__ */ jsx(TextField, { ...textFieldProps, autoComplete: "name", config: useConfigWithExtraValidation(textFieldProps.config, getInvalidNameError) });
}
NameField.propTypes = TextField.propTypes;
NameField.defaultProps = TextField.defaultProps;
export {
  NameField as default,
  getInvalidNameError
};
